module.exports = __webpack_public_path__ + "static/media/floor plan icon.f8144ac3.svg";